import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import AppNavigator from "../../Navigators/AppNavigator";
import { isLoggedIn } from "../../Stores/redux/Persisted/Selectors";
import authModule from "../../Modules/auth/auth-module";

class RootScreen extends Component {
  async componentDidMount() {
    if (this.props.isLoggedIn) {
      authModule.initAuth({
        userId: this.props.user?._id,
      });
    }
  }

  render() {
    return <AppNavigator />;
  }
}

RootScreen.propTypes = {
  isLoggedIn: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  isLoggedIn: isLoggedIn(state),
  user: state.pState.AUTH?.user,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(RootScreen);
